import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchCampaignStatus } from "../api/fetchCampaignStatus/fetchCampaignStatusApi";
import {
  CampaignStatusItem,
  FetchCampaignStatusRequest,
  FetchCampaignStatusResponse,
} from "../api/fetchCampaignStatus/types";
import { AppDispatch, AppThunk } from "@/app/store";

interface CampaignStatusState {
  campaigns: CampaignStatusItem[];
  totalCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: CampaignStatusState = {
  campaigns: [],
  totalCount: 0,
  loading: false,
  error: null,
};

const campaignStatusDataSlice = createSlice({
  name: "campaignStatusData",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setCampaigns: (
      state,
      action: PayloadAction<{
        campaigns: CampaignStatusItem[];
        totalCount: number;
      }>,
    ) => {
      state.campaigns = action.payload.campaigns;
      state.totalCount = action.payload.totalCount;
    },
  },
});

export const { setLoading, setError, setCampaigns } =
  campaignStatusDataSlice.actions;

export const fetchCampaignStatusAction =
  (requestParams: FetchCampaignStatusRequest): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    try {
      const response: FetchCampaignStatusResponse =
        await fetchCampaignStatus(requestParams);

      dispatch(
        setCampaigns({
          campaigns: response.data,
          totalCount: response.meta?.totalCount ?? 0,
        }),
      );
    } catch (error) {
      if (error instanceof Error) {
        dispatch(setError(error.message));
      } else {
        dispatch(setError("Failed to fetch campaign status"));
      }
    } finally {
      dispatch(setLoading(false));
    }
  };

export default campaignStatusDataSlice.reducer;
